<template>
  <o-card>
    <template slot="header">
      <h5 class="mb-0">{{ $t('sandoz.bank_data') }}</h5>
    </template>

    <o-checkbox :label="$t('sandoz.vat')"
                v-model="vatBound"
                :disabled="readonly"/>

    <o-form-group v-if="vatBound" :label="$t('sandoz.vat_number')">
      <b-form-input v-model="item.vat_number" :readonly="readonly"/>
    </o-form-group>

    <b-row>
      <b-col md="6">
        <o-form-group :label="$t('sandoz.bank_name')">
          <b-form-input v-model="item.bank_name" :readonly="readonly"/>
        </o-form-group>
        <o-form-group :label="$t('sandoz.bank_address')">
          <b-form-textarea v-model="item.bank_address" :disabled="readonly" rows="2"/>
        </o-form-group>
      </b-col>
      <b-col md="6">
        <o-form-group :label="$t('sandoz.accountholder_name')">
          <b-form-input v-model="item.accountholder_name" :readonly="readonly"/>
        </o-form-group>
        <o-form-group :label="$t('sandoz.accountholder_address')">
          <b-form-textarea v-model="item.accountholder_address" :disabled="readonly" rows="2"/>
        </o-form-group>
      </b-col>
    </b-row>

    <o-form-group :label="$t('sandoz.iban_no')" :state="ibanValid">
      <b-form-input v-model="item.iban_no" :readonly="readonly" :state="ibanValid"/>
      <b-form-invalid-feedback v-if="ibanValid === false">{{ $t('sandoz.iban_format_invalid') }}</b-form-invalid-feedback>
    </o-form-group>
  </o-card>
</template>

<script>
import sectionMixin from '../sectionMixin'

/**
 * IBAN / bank / account holder block. Mirrors the ice_peak/ContractDetail.vue bank section.
 * VAT is stored as 'x' or null (matches the legacy convention).
 */
export default {
  name: 'SectionBankData',
  mixins: [sectionMixin],
  computed: {
    vatBound: {
      get() {
        return this.item.vat === 'x' || this.item.vat === true
      },
      set(v) {
        this.$set(this.item, 'vat', v ? 'x' : null)
      }
    },
    ibanValid() {
      const iban = (this.item.iban_no || '').replace(/\s+/g, '')
      if (!iban) {
        return null
      }
      // Lenient: 15-34 alphanumeric chars starting with 2 letters. Real validation lives server-side.
      return /^[A-Z]{2}[0-9A-Z]{13,32}$/.test(iban) ? null : false
    }
  }
}
</script>
